<template>
    <div id="app">
        <page-header :user="user" :show-search-box="false"></page-header>
        <main role="role" class="lexprogress-wrapper">
            <!-- 主頁內容都放在 main 裡面-->
            <div class="container main-content-wrapper">
                <h3>{{$t('element_tos.tos')}}</h3>
                <p>{{$t('element_tos.tos_1')}}</p>
                <p>
                    {{$t('element_tos.tos_2')}}<a class="term-link" href="/">www.iyuyan.net</a>{{$t('element_tos.tos_3')}}
                </p>
                <p>
                    {{$t('element_tos.tos_4')}}
                </p>
                <ol class="tos-ol">
                    <li class="tos-li">
                        {{$t('element_tos.tos_5')}}
                        <p>{{$t('element_tos.tos_6')}}</p>
                        <p>{{$t('element_tos.tos_7')}}</p>
                        <p>
                            <ol class="tos-ol">
                                <li class="tos-li">
                                    {{$t('element_tos.tos_8')}} <a class="term-link" href="https://www.youtube.com/t/terms">{{$t('element_tos.tos_9')}}</a>{{$t('element_tos.tos_10')}} <a class="term-link" href="https://policies.google.com/privacy">{{$t('element_tos.tos_11')}}</a>{{$t('element_tos.tos_12')}}<a class="term-link" href="https://myaccount.google.com/permissions">{{$t('element_tos.tos_13')}}</a>{{$t('element_tos.tos_14')}}
                                </li>
                                <li class="tos-li">
                                    {{$t('element_tos.tos_15')}} <a class="term-link" href="https://policies.google.com/terms">{{$t('element_tos.tos_16')}}</a>{{$t('element_tos.tos_17')}} <a class="term-link" href="https://policies.google.com/privacy">{{$t('element_tos.tos_18')}}</a>。
                                </li>
                                <li class="tos-li">
                                    {{$t('element_tos.tos_19')}} <a class="term-link" href="https://policies.google.com/terms">{{$t('element_tos.tos_20')}}</a>{{$t('element_tos.tos_21')}}<a class="term-link" href="https://policies.google.com/privacy">{{$t('element_tos.tos_22')}}</a>。
                                </li>
                                <li class="tos-li">
                                    {{$t('element_tos.tos_23')}} <a class="term-link" href="https://www.newebpay.com/website/Page/content/service_policy">{{$t('element_tos.tos_24')}}</a>{{$t('element_tos.tos_25')}} <a class="term-link" href="https://www.newebpay.com/website/Page/content/privacy">{{$t('element_tos.tos_26')}}</a>。
                                </li>
                            </ol>
                        </p>
                    </li>
                    <li class="tos-li">
                        {{$t('element_tos.tos_27')}}
                        <ol class="tos-ol">
                            <li class="tos-li">
                                {{$t('element_tos.tos_28')}}
                                <p>
                                    {{$t('element_tos.tos_29')}}
                                </p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_30')}}
                                <p>
                                    {{$t('element_tos.tos_31')}}
                                </p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_32')}}
                                <p>
                                    {{$t('element_tos.tos_33')}}
                                    <ol class="tos-ol">
                                        <li class="tos-li">{{$t('element_tos.tos_34')}}</li>
                                        <li class="tos-li">{{$t('element_tos.tos_35')}}</li>
                                        <li class="tos-li">{{$t('element_tos.tos_36')}}</li>
                                        <li class="tos-li">{{$t('element_tos.tos_37')}}</li>
                                        <li class="tos-li">{{$t('element_tos.tos_38')}}</li>
                                        <li class="tos-li">{{$t('element_tos.tos_39')}}</li>
                                        <li class="tos-li">{{$t('element_tos.tos_40')}}</li>
                                    </ol>
                                </p>
                                <p>
                                    {{$t('element_tos.tos_41')}}
                                </p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_42')}}
                                <p>{{$t('element_tos.tos_43')}}</p>
                                <p>{{$t('element_tos.tos_44')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_45')}}
                                <p>{{$t('element_tos.tos_46')}}<a class="term-link" href="/tos.html">{{$t('element_tos.tos_47')}}</a>{{$t('element_tos.tos_48')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_49')}}
                                <p>{{$t('element_tos.tos_50')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_51')}}
                                <p>{{$t('element_tos.tos_52')}}</p>
                            </li>
                        </ol>
                    </li>
                    <li class="tos-li">
                        {{$t('element_tos.tos_53')}}
                        <ol class="tos-ol">
                            <li class="tos-li">
                                {{$t('element_tos.tos_54')}}
                                <p>{{$t('element_tos.tos_55')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_56')}}
                                <p>{{$t('element_tos.tos_57')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_58')}}
                                <p>{{$t('element_tos.tos_59')}}</p>
                            </li>
                        </ol>
                    </li>
                    <li class="tos-li">
                        {{$t('element_tos.tos_60')}}
                        <p>{{$t('element_tos.tos_61')}}</p>
                        <p>{{$t('element_tos.tos_62')}}</p>
                        <ol class="tos-ol">
                            <li class="tos-li">
                                {{$t('element_tos.tos_63')}}
                                <p>{{$t('element_tos.tos_64')}}</p>
                                <p>{{$t('element_tos.tos_65')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_66')}}
                                <p>{{$t('element_tos.tos_67')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_68')}}
                                <p>{{$t('element_tos.tos_69')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.added_20211011-1')}}
                                <p>{{$t('element_tos.added_20211011-1-1')}}</p>
                            </li>
                        </ol>
                    </li>
                    <li class="tos-li">
                        {{$t('element_tos.added_20211011-2')}}
                        <p>{{$t('element_tos.added_20211011-2-1')}}</p>
                    </li>
                    <li class="tos-li">
                        {{$t('element_tos.tos_70')}}
                        <ol class="tos-ol">
                            <li class="tos-li">
                                {{$t('element_tos.tos_71')}}
                                <p>{{$t('element_tos.tos_72')}}</p>
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_73')}}
                                <p>{{$t('element_tos.tos_74')}}</p>
                            </li>
                        </ol>
                    </li>
                    <li class="tos-li">
                        {{$t('element_tos.tos_75')}}
                        <p>{{$t('element_tos.tos_76')}}</p>
                        <ol class="tos-ol">
                            <li class="tos-li">
                                {{$t('element_tos.tos_77')}}
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_78')}}
                            </li>
                            <li class="tos-li">
                                {{$t('element_tos.tos_79')}}
                            </li>
                        </ol>
                        <p>
                            {{$t('element_tos.tos_80')}}
                        </p>
                    </li>
                    <li class="tos-li">
                        {{$t('element_tos.tos_81')}}
                        <p>{{$t('element_tos.tos_82')}}</p>
                    </li>
                    <li class="tos-li">
                        {{$t('element_tos.tos_83')}}
                        <p>{{$t('element_tos.tos_84')}}</p>
                    </li>
                </ol>
            </div>
        </main>
        <page-footer></page-footer>
        <!--
            <v-facebook-login app-id="252521361855678" v-on:login="userLogined"></v-facebook-login>
            <HelloWorld msg="Welcome to Your Vue.js App"/>
        -->
    </div>
</template>

<script>
    import appMixin from '@/lib/AppBaseMixin.js';

    import PageHeader from '@/components/Elements/PageHeader.vue';
    import PageFooter from '@/components/Elements/PageFooter.vue';

    export default {
        name: 'App',
        mixins: [appMixin],
        components: {
            PageHeader,
            PageFooter
        },
        data: function () {
            return {
            };
        },
        methods: {
        },
        mounted: function () {
        },
    }
</script>
<style>
    body {
        background-color: #F7F8FA;
    }

    .lexprogress-wrapper {
        background-color: #F7F8FA;
    }

    .main-content-wrapper {
        padding-bottom: 60px;
    }

    .term-link {
        text-decoration: underline;
        color: blue;
    }

        .term-link:hover {
            text-decoration: underline;
            color: blue;
        }

    .tos-ol {
        counter-reset: item
    }

    .tos-li {
        display: block
    }

        .tos-li:before {
            content: counters(item, ".") " ";
            counter-increment: item
        }
</style>
